import * as d3 from 'd3';

function classToColor(txClass) {
    switch (txClass) {
        case "eth_transfer":
            return "#26a6ed"
        case "token":
            return "#00A36C"
        case "dex":
            return "#4b2caf"
        case "cex":
            return "#ff697c"
        case "defi":
            return "#e59c23"
        case "mev":
            return "#FFFF00"
        case "bridge":
            return "#8c1434"
        case "unknown":
            return "#E5E4E2"
        default:
            return "#E5E4E2"
    }
}

function transactionLink(txhash) {
    return "https://etherscan.io/tx/" + txhash
}

function log(value) {
    console.log(value)
}

export default class TxPoolUI {
    static RESCALE_Y_INTERVAL = 3
    static DISCARD_TIMESPAN = 120000 // in milliseconds

    constructor(element) {
        this.padding = { top: 15, right: 15, bottom: 45, left: 50 };
        var parentDiv = document.querySelector(element); // Replace with the ID of your parent div
        var rect = parentDiv.getBoundingClientRect();
        this.height = rect.height;
        this.width = rect.width;
        this.format4 = d3.format('.4f');

        this.svg = d3.select(element).append("svg")
            .attr("width", this.width)
            .attr("height", this.height)

        this.x = d3.scaleLog()
            .domain([0.001, 1000])  // Changed from 0.01 to 0.001
            .range([this.padding.left, this.width - this.padding.right])
            .nice();

        this.y = d3.scaleLinear()
            .domain([1, 100])
            .range([this.height - this.padding.bottom, this.padding.top]);

        var axis = d3.axisBottom(this.x)
            .tickValues([0.001, 0.01, 0.1, 0.5, 1, 2, 5, 10, 100, 1000])
            .tickFormat((d) => {
                if (d >= 1) {
                    return d3.format(".0f")(d);
                } else if (d >= 0.01) {
                    return d3.format(".2f")(d);  // Changed from .1f to .2f
                } else {
                    return d3.format(".3f")(d);
                }
            });

        this.xaxis = this.svg.append("g")
            .attr("transform", `translate(0, ${this.height - this.padding.bottom})`)
            .call(axis);

        this.yaxis = this.svg.append("g")
            .attr("transform", `translate(${this.padding.left}, 0)`)
            .call(d3.axisLeft(this.y));

        this.vline2 = this.svg.append('line')
            .attr('x1', this.width - this.padding.right)
            .attr('x2', this.width - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('y2', this.height - this.padding.bottom)
            .attr('stroke-width', '1')
            .attr('stroke', 'white')

        // X label
        this.xlabel = this.svg.append('text')
            .attr('x', this.width / 2)
            .attr('y', this.height - 5)
            .attr('text-anchor', 'middle')
            .style('font-family', 'Courier,Courier New,slab-serif')
            .style('font-size', 12)
            .style("font-weight", "bold")
            .style('fill', '#d3d3d3')
            .text('Priority Fee (Gwei)');

        // Y label
        this.ylabel = this.svg.append('text')
            .attr('text-anchor', 'middle')
            .attr('transform', 'translate(12,' + (this.height - this.padding.bottom + this.padding.top) / 2 + ')rotate(-90)')
            .style('font-family', 'Courier,Courier New,slab-serif')
            .style('font-size', 12)
            .style("font-weight", "bold")
            .style('fill', '#d3d3d3')
            .text('Base Fee (Gwei)');

        // Add a tooltip div. Here I define the general feature of the tooltip: stuff that do not depend on the data point.
        // Its opacity is set to 0: we don't see it by default.
        this.tooltip = d3.select("#tx_pool")
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")

        // A function that change this tooltip when the user hover a point.
        // Its opacity is set to 1: we can now see it. Plus it set the text and position of tooltip depending on the datapoint (d)
        this.mouseover = (e, d) => {
            this.tooltip = this.tooltip
                .style("opacity", 1)
        }

        this.mousemove = (e, d) => {
            const [x, y] = d3.pointer(e);

            // Calculate the tooltip position relative to the mouse cursor
            const tooltipLeft = x + 10; // Add an offset to adjust the position
            const tooltipTop = y + 10; // Add an offset to adjust the position

            var tx = d[1]
            this.tooltip = this.tooltip
                .html(`
                <div class='tooltip-tx'>
                    <strong>Hash ${tx.hash}</strong><br><br>
                    <strong style="display: inline-block; width: 100px;">Class:</strong> ${tx.class.toUpperCase()}<br>
                    <strong style="display: inline-block; width: 100px;">From:</strong> ${tx.from}<br>
                    <strong style="display: inline-block; width: 100px;">To:</strong> ${tx.to}<br>
                    <strong style="display: inline-block; width: 100px;">Value:</strong> ${tx.value} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Fee:</strong> ${(tx.fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Tip:</strong> ${(tx.tip * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Gas Limit:</strong> ${tx.gas_limit}<br>
                </div>
                `)
                .style("left", `${tooltipLeft}px`) // It is important to put the +90: other wise the tooltip is exactly where the point is an it creates a weird effect
                .style("top", `${tooltipTop - this.height}px`)
        }

        this.mousemove2 = (e, d) => {
            const [x, y] = d3.pointer(e);

            // Calculate the tooltip position relative to the mouse cursor
            const tooltipLeft = x + 10; // Add an offset to adjust the position
            const tooltipTop = y + 10; // Add an offset to adjust the position

            var tx = d
            this.tooltip = this.tooltip
                .html(`
                <div class='tooltip-tx'>
                    <strong>Hash ${tx.hash}</strong><br><br>
                    <strong style="display: inline-block; width: 100px;">Class:</strong> ${tx.class.toUpperCase()}<br>
                    <strong style="display: inline-block; width: 100px;">From:</strong> ${tx.from}<br>
                    <strong style="display: inline-block; width: 100px;">To:</strong> ${tx.to}<br>
                    <strong style="display: inline-block; width: 100px;">Value:</strong> ${tx.value} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Fee:</strong> ${(tx.fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Tip:</strong> ${(tx.tip * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Gas Limit:</strong> ${tx.gas_limit}<br>
                </div>
                `)
                .style("left", `${tooltipLeft}px`) // It is important to put the +90: other wise the tooltip is exactly where the point is an it creates a weird effect
                .style("top", `${tooltipTop - this.height}px`)
        }

        // A function that change this tooltip when the leaves a point: just need to set opacity to 0 again
        this.mouseleave = (e, d) => {
            this.tooltip = this.tooltip
                .html("")
                .style("left", `0px`)
                .style("top", `0px`)
                .style("opacity", 0)
        }

        // data
        this.pool_summaries = []
        this.transactions = new Map();
        this.lastBlock = 0
        this.yaxisRescale = 0
        this.yaxisMin = 0
        this.yaxisMax = 100
        this.xaxisMax = 1000
        this.format4 = d3.format('.2f');
    }

    newBlockSummary = (block_summary) => {
        if (this.written !== undefined) {
            this.written.remove()
        }
    }

    newPoolSummary = (pool_summary) => {
        // add new txs
        for (const txhash in pool_summary.new) {
            this.transactions.set(txhash, pool_summary.new[txhash])
        }
        // separate written txs
        var written = []
        pool_summary.written.forEach(txhash => {
            if (this.transactions.has(txhash)) {
                written.push(this.transactions.get(txhash))
            }
            this.transactions.delete(txhash)
        });

        const txsToDelete = [];
        // iterate through all txs
        const currentMillis = new Date().getTime();
        this.transactions.forEach((tx, txhash) => {
            if (currentMillis - tx.timestamp / 1e6 >= TxPoolUI.DISCARD_TIMESPAN) {
                // old tx -> discard
                txsToDelete.push(txhash)
            } else if (tx.price > 0) {
                // legacy tx
                if (tx.price > pool_summary.next_base_fee) {
                    tx.fee = pool_summary.next_base_fee
                    tx.tip = tx.price - pool_summary.next_base_fee
                } else {
                    if (tx.fee === 0 && tx.tip <= 0) {
                        tx.fee = tx.price
                        tx.tip = 1 / 1e18
                    }
                }
                this.transactions.set(txhash, tx)
            }
        });
        // delete old txs
        txsToDelete.forEach((txhash) => {
            this.transactions.delete(txhash);
        });
        // rescale yaxis every RESCALE_Y_INTERVAL blocks
        if (pool_summary.block > this.yaxisRescale) {
            this.rescaleYAxis(pool_summary)
            this.yaxisRescale = pool_summary.block + TxPoolUI.RESCALE_Y_INTERVAL
        }
        // highlight written txs
        this.drawTxs()
        if (written.length > 0) {
            this.drawWritten(written)
        }
        this.drawBaseFeeLine(pool_summary)
        this.drawPrioFeeLine(pool_summary)
    }

    drawTxs = () => {
        if (this.dots !== undefined) {
            this.dots.remove()
        }

        if (this.written !== undefined && this.clearWritten) {
            this.written.remove()
            this.clearWritten = false
        }

        this.dots = this.svg.append("g")
            .attr("stroke-width", 1.5)
            .selectAll("circle")
            .data(this.transactions)
            .join("circle")
            .attr("cx", (d, i) => this.x(this.capTip(d[1].tip * 1e9)))
            .attr("cy", (d, i) => this.y(this.capFee(d[1].fee * 1e9)))
            .attr("r", (d) => {
                return 3 + Math.min(d[1].gas_limit / 1000000, 2)
            })
            .attr("stroke", (d) => classToColor(d[1].class))
            .style("fill", "transparent")
            .style("pointer-events", "all") // Allow click events on transparent area
            .style("cursor", "pointer") // Set the pointer cursor
            .on("click", function () {
                // Open link in a new tab when a dot is clicked
                const data = d3.select(this).datum();
                window.open(transactionLink(data[1].hash), "_blank");
            })
            .on("mouseover", this.mouseover)
            .on("mousemove", this.mousemove)
            .on("mouseleave", this.mouseleave)
    }

    capFee = (fee) => {
        if (fee > this.yaxisMax) {
            return this.yaxisMax
        } else if (fee < this.yaxisMin) {
            return this.yaxisMin
        } else {
            return fee
        }
    }

    capTip = (tip) => {
        if (tip > this.xaxisMax) {
            return this.xaxisMax
        } else if (tip < 0.001) {  // Changed from 0.01 to 0.001
            return 0.001
        } else {
            return tip
        }
    }

    drawWritten = (writtenTxs) => {
        if (this.written !== undefined) {
            this.written.remove()
        }

        this.written = this.svg.append("g")
            .attr("fill", "#5caf56")
            .selectAll("circle")
            .data(writtenTxs)
            .join("circle")
            .attr("cx", (d, i) => this.x(this.capTip(d.tip * 1e9)))
            .attr("cy", (d, i) => this.y(this.capFee(d.fee * 1e9)))
            .attr("r", (d) => {
                return 3 + Math.min(d.gas_limit / 1000000, 2)
            })
            .style("cursor", "pointer") // Set the pointer cursor
            .style("pointer-events", "all") // Allow click events on transparent area
            .on("click", function () {
                // Open link in a new tab when a dot is clicked
                const data = d3.select(this).datum();
                window.open(transactionLink(data.hash), "_blank");
            })
            .on("mouseover", this.mouseover)
            .on("mousemove", this.mousemove2)
            .on("mouseleave", this.mouseleave)

        setTimeout(() => {
            this.clearWritten = true
        }, 1000);
    }

    drawBaseFeeLine = (pool_summary) => {
        if (pool_summary.block > this.lastBlock) {
            // clear old line
            if (this.baseFeeLine !== undefined) {
                this.baseFeeLine.remove()
            }
            if (this.baseFeeLabel !== undefined) {
                this.baseFeeLabel.remove()
            }
            if (this.baseFeeRect !== undefined) {
                this.baseFeeRect.remove()
            }
            var baseFee = pool_summary.next_base_fee * 1e9
            // Define starting and ending points
            const startPoint = { x: this.padding.left, y: this.y(baseFee) };
            const endPoint = { x: this.width - this.padding.right, y: this.y(baseFee) };

            this.baseFeeLine = this.svg.append('line')
                .attr('x1', startPoint.x)
                .attr('y1', startPoint.y)
                .attr('x2', endPoint.x)
                .attr('y2', endPoint.y)
                .attr('stroke-dasharray', '2,2')
                .attr('stroke', '#d3d3d3');

            this.baseFeeLabel = this.svg.append('text')
                .attr('class', 'label')
                .attr('x', this.padding.left + 60)
                .attr('y', this.y(baseFee) - 5)
                .attr('text-anchor', 'middle')
                .style("font-family", "Courier,Courier New,slab-serif")
                .style('font-size', '14px')
                .style('fill', '#d3d3d3')
                .text(d => `${this.format4(baseFee)} Gwei`);

            // Append the rectangle to the SVG
            this.baseFeeRect = this.svg.append("rect")
                .attr("x", startPoint.x)
                .attr("y", startPoint.y)
                .attr("width", this.width - this.padding.right - this.padding.left)
                .attr("height", this.y(this.y.domain()[0]) - this.y(baseFee))
                .attr("fill", "#ff697c")
                .attr("fill-opacity", 0.1);

            this.lastBlock = pool_summary.block
        }
    }

    drawPrioFeeLine = (pool_summary) => {
        if (this.prioFeeLine !== undefined) {
            this.prioFeeLine.remove()
        }

        var prioFee = pool_summary.min_priority_fee / 1e9

        // Don't draw if priority fee is 0 or too small
        if (prioFee <= 0.001) {
            return;
        }

        const startPoint = { x: this.x(prioFee), y: this.padding.top };
        const endPoint = { x: this.x(prioFee), y: this.height - this.padding.bottom };

        this.prioFeeLine = this.svg.append('line')
            .attr('x1', startPoint.x)
            .attr('y1', startPoint.y)
            .attr('x2', endPoint.x)
            .attr('y2', endPoint.y)
            .attr('stroke-width', '1')
            .attr('stroke-dasharray', '2,2')
            .attr('stroke', '#d3d3d3');
    }

    rescaleYAxis = (pool_summary) => {
        this.yaxisMax = (pool_summary.next_base_fee * 1e9 * 2)
        this.yaxisMin = (pool_summary.next_base_fee * 1e9 * 0.5)
        this.y.domain([(pool_summary.next_base_fee * 1e9 * 0.5), (pool_summary.next_base_fee * 1e9 * 2)]);

        if (this.yaxis !== undefined) {
            this.yaxis.remove()
        }
        this.yaxis = this.svg.append("g")
            .attr("transform", `translate(${this.padding.left}, 0)`)
            .call(d3.axisLeft(this.y));
    }

}
